/*eslint-disable */

import Vue from "vue";

const url = 'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL + '/ws/common/';
let socket;
var checkSocketStatus = false;
var CheckCommonRoomId;
const token = localStorage.getItem('token');
let pingInterval; // Declare pingInterval to store the interval ID

const emitter = new Vue({
  methods: {
    isOpen() {
      let status = '';
      if (socket && socket.readyState) {
        status = socket.readyState;
      }
      return status;
    },
    emit(message) {
      socket.send(JSON.stringify(message));
    },
    send(message) {
      if (1 === socket.readyState) socket.send(message);
    },
    close() {
      checkSocketStatus = true;
      clearInterval(pingInterval); // Clear the ping interval when closing
      if (socket.readyState && 1 === socket.readyState) {
        emitter.$emit("close", JSON.stringify({ message: 'Closing Chat', type: 'connectionClosed' }));
        socket.close();
        socket = null; // prevent memory leak
      }
    },
    connect(roomId) {
      var __self = this;
      CheckCommonRoomId = roomId;
      socket = new WebSocket(url + roomId + "/?token=" + token);
      socket.onmessage = (response) => {
        let message = JSON.parse(response.data);
        // console.log(message, "message Request");
        if (message.type === 'userLogin') {
          emitter.$emit("userLogin", message);
        } else if (message.type === 'userStatus') {
          emitter.$emit("userStatus", message);
        } else if (message.type === 'self_user_stat') {
          emitter.$emit("selfUserStatus", message);
        } else if (message.type === "TypingEventForChat") {
          emitter.$emit("TypingEventForSelectedUserNotification", message);
        } else if (message.type === "newMessageNotification") {
          emitter.$emit("newMessageNotifications", message);
        } else if (message.type === "videoCalling") {
          emitter.$emit("videoCallingNotification", message);
        } else if (message.type === 'videoCallAccepted') {
          emitter.$emit("videoCallAcceptedNotification", message);
        } else if (message.type === 'videoCallDecline') {
          emitter.$emit("videoCallDeclinedNotification", message);
        } else if (message.type === 'videoAlertPopupClose') {
          emitter.$emit("videoCallAlertPopupClosed", message);
        } else if (message.type === 'videoCallNotReceived') {
          emitter.$emit("videoCallDeclinedNotification", message);
        } else if (message.type === 'userLogout') {
          if (message.videoCallingtypedata) {
            emitter.$emit("autoMissedCallEvent", message.videoCallingtypedata);
          }
          emitter.$emit("userLogout", message);
        }
      };
      socket.onopen = (event) => {
        emitter.$emit("open", event);
        emitter.$emit("connection", JSON.stringify({ message: 'connection created successfully', type: 'connection' }));
        // Start sending pings every 30 seconds after connection is open
        pingInterval = setInterval(() => {
          if (socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({ type: 'ping' })); // Send a ping message
          }
        }, 30000); // 30 seconds
      };
      socket.onclose = (event) => {
        clearInterval(pingInterval); // Clear the ping interval on close
        if (checkSocketStatus == false) {
          setTimeout(() => {
            __self.connect(CheckCommonRoomId);
          }, 1000)
        } else {
          // Socket was intentionally closed, no reconnect
        }
      };
      socket.onerror = (err) => {
        emitter.$emit("error", err);
      };
    }
  }
});

export default emitter;